module.exports = __webpack_public_path__ + "img/image-3.4053982d.jpg";